export { default } from './SoapPast';

export { default as SoapPastTable } from './SoapPastTable';